export const CUSTOMER_STORAGE_KEY = "selected-customer-id";
import { COMPANY_CODE } from "../../client_identity";

export const DEFAULT_CUSTOMER_ID = COMPANY_CODE;
